import React from "react";
import {
  Datagrid,
  List,
  SelectInput,
  SimpleShowLayout,
  TextField,
  TextInput,
  ReferenceInput,
  FormDataConsumer,
  ReferenceField,
  required,
  SimpleForm, Edit,
  AutocompleteArrayInput,
  BooleanInput,

  Filter,
} from "react-admin";

// import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import { Roles } from "../../constants/choices"

const SearchAdmin = (props) => {
  // const { permissions } = usePermissions();

  return (
    <Filter {...props}>
      <ReferenceInput variant="outlined" label="واحد  " alwaysOn source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceInput filter={{ unitId: props?.filterValues?.unitId }} disabled={(props?.filterValues?.unitId === undefined ? true : false)} alwaysOn variant="outlined" label=" زیرواحد " source="unitProcessorId" reference="unitProcessor" >
        <SelectInput optionText="title" />
      </ReferenceInput>

      {/* <ReferenceInput variant="outlined" label="پردازنده " source="unitProcessorId" reference="unitProcessor" >
        <SelectInput optionText="title" />
      </ReferenceInput> */}


      {/* <AutocompleteInput optionText="refNum" alwaysOn/> */}
      <TextInput label="نام" source="name" variant="outlined" alwaysOn />
    </Filter>
  )
};

export const AdminUserList = (props) => (
  <List {...props} perPage={500} filters={<SearchAdmin />}>
    <Datagrid rowClick="edit" mutationMode="pessimistic" {...props} undoable={false}>
      <TextField source="name" />
      <TextField source="lastSMSCode" />
      <ReferenceField link="show" label=" واحد مربوطه" source="unitId" reference="unit" >
        <TextField source="title" />
      </ReferenceField>
      <ReferenceField link="show" label="پردازنده " source="unitProcessorId" reference="unitProcessor" >
        <TextField source="title" />
      </ReferenceField>

      {/* <TextField source="phoneNumber" /> */}
      <TagsField source="roles" />
      {/* <SelectField source="role" choices={Roles} /> */}

      {/* <AutocompleteArrayInput source="roles" choices={Roles} /> */}
    </Datagrid>
  </List>
);
const TagsField = ({ record }) => (
  <ul>
    {record.roles?.map(item => (
      <div key={item}>{(Roles.find(x => (x.visible && x.id === item))?.name)}</div>
    ))}
  </ul>
)

export const AdminUserEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect="list" submitOnEnter={false} variant="outlined">
      <TextInput source="name" />
      <TextInput source="userNumber" />

      <TextInput source="phoneNumber" />
      <TextInput disabled source="lastSMSCode" />
      <ReferenceInput label="واحد مربوطه " source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <BooleanInput  source="hasMainPanelAccess" />
      <BooleanInput defaultValue={true} source="hasHrAccess" />
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <ReferenceInput filter={{ unitId: (formData.unitId === undefined) ? "alaki" : formData.unitId }} label=" پردازنده " source="unitProcessorId" reference="unitProcessor" >
            <SelectInput optionText="title"   {...rest} />
          </ReferenceInput>
        )}
      </FormDataConsumer>
      <AutocompleteArrayInput source="roles" choices={Roles} />


    </SimpleForm>
  </Edit >
);

export const AdminUserShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="userNumber" />
      <TextField source="unit" />
      <TextField source="unitProcessor" />
      <TextField source="phoneNumber" />
      <TextField source="lastSMSCode" />
      <TextField source="role" />
    </SimpleShowLayout>
  </ShowView>
);

export const AdminUserCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="name" autoComplete="off" />
    <TextInput source="userNumber" autoComplete="off" />
    <BooleanInput source="hasMainPanelAccess" />
    <BooleanInput source="hasHrAccess" />
    <ReferenceInput label="واحد مربوطه "  validate={required()} source="unitId" reference="unit" >
      <SelectInput optionText="title" />
    </ReferenceInput>

    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <ReferenceInput filter={{ unitId: formData.unitId }} label=" پردازنده "  validate={required()} source="unitProcessorId" reference="unitProcessor" >
          <SelectInput optionText="title"   {...rest} />
        </ReferenceInput>
      )}
    </FormDataConsumer>

    <AutocompleteArrayInput  validate={required()}  source="roles" choices={Roles} />
    <TextInput source="phoneNumber" validate={required()}  autoComplete="off" />
  </CreateView>
);
